import './styles.scss';
import React, {useState, useEffect} from 'react'

import RichText from '../RichText'
import {Col, Container, Row} from "react-bootstrap";
import useCardLink, {IUseCardLink} from "./useCardLink";

import {NavigateFunction} from "react-router/dist/lib/hooks";
import {useNavigate} from "react-router-dom";
import {CMSLinkType} from "../Link";

export const ContentGrid: React.FC<
  {
    fields: any
  }
> = props => {
  const {
    fields
  } = props

  const [numColumns, setNumColumns] = useState<number>(0);
  const {getURL}: IUseCardLink = useCardLink();
  const navigate:NavigateFunction = useNavigate();

  useEffect(()=>{
    let columns: number = 0;
    fields.rows.forEach((r:any)=>{
      columns = r.cells.length > columns ? r.cells.length : columns
    })
    setNumColumns(columns)
  }, [setNumColumns, fields.rows])

  const handleClick = (link:CMSLinkType):void => {
    const url: string = getURL(link);
    navigate(url)
  }

  const textAlignment = (): string => {
    switch (fields.cellAlignment) {
      case 'left':
        return 'text-start';
      case 'right':
        return 'text-end';
      default:
        return 'text-center';
    }
  }

  return (
    <Container className={'content-grid ' + textAlignment()}>
      <div className={'my-3'}>
        {fields.useLeadingHeader &&  <RichText content={fields.leadingHeader}/>}
      </div>

      {fields.rows.map((row:any, index: number) => {
        return <Row key={index} className={(row.columnHeaders ? 'column-headers': '')}>
          {row.cells.map((cell:any, i: number) => {
            return <Col
              lg={10/numColumns}
              className={'content-card col px-3 py-4 bg-grey-lighter m-2 border-0'}
              key={i}
              onClick={()=>handleClick(cell.link)}
            >
              {cell.richText.map((c:any, j:number) => {
                return <RichText content={[c]} key={j}/>
              })}
            </Col>
          })}
        </Row>
      })}
    </Container>
  )
}
